import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import uuidv1 from 'uuid/v1';
import withStores from '@studionand/ada-next/src/stores/withStores';
import AnsprechpartnerBox from './Box';
// import PlusIcon from '../../../../../icons/Plus';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import { useResponsiveCols } from '../../../../../utils/useCols';

const ANSPRECHPARTNER = {
  name: 'Max Mustermann',
  title: 'Ansprechpartner',
  tel: '+4930 1234 567 89',
  email: 'max@mustermann.de',
  img: null,
};

const styles = theme => ({
  dummy: {
    cursor: 'pointer',
    '@global .name': {
      fontWeight: theme.typography.fontWeightBold,
    },
    '&:hover $dummyImg': {
      backgroundColor: theme.editorPalette.grey[300],
    },
  },
  dummyText: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%,-50%)',
  },
  dummyImg: {
    backgroundColor: theme.editorPalette.grey[200],
    width: '100%',
    height: 250,
    display: 'flex',
    alignItem: 'center',
    justifyContent: 'center',
    position: 'relative',
    transition: 'background-color ease-in-out 225ms',
  },
});

@withStyles(styles)
@withStores('appStore', 'pagesStore')
@observer
class AnsprechpartnerBlock extends Component { // eslint-disable-line
  static propTypes = {
    blockProps: PropTypes.object.isRequired,
    contentState: PropTypes.object.isRequired,
    block: PropTypes.object.isRequired,
  };
  state = {
    editable: false,
    isModalOpen: false,
  };

  get entityKey() {
    return this.props.block.getEntityAt(0);
  }

  get entity() {
    return this.props.contentState.getEntity(this.entityKey);
  }

  get data() {
    const data = this.entity.getData().ansprechpartner;
    return data ? JSON.parse(data) : [];
  }

  handleReceiveInput = (e, uuid, key) => {
    e.preventDefault();
    e.stopPropagation();
    const value = e.target.innerText;
    const indexToUpdate = this.data.findIndex(i => i.uuid === uuid);
    const entryToUpdate = this.data[indexToUpdate];
    const entityData = this.data;
    entityData[indexToUpdate] = {
      ...entryToUpdate,
      [key]: value,
    };
    this.updateEntityData(entityData);
  };

  handleSetImage = (uuid, mediaUUID) => {
    const indexToUpdate = this.data.findIndex(i => i.uuid === uuid);
    const entryToUpdate = this.data[indexToUpdate];
    const entityData = this.data;
    entityData[indexToUpdate] = {
      ...entryToUpdate,
      img: mediaUUID,
    };
    this.updateEntityData(entityData);
  };

  addAnsprechpartner = () => {
    const NEW_ANSPRECHPARTNER = {
      ...ANSPRECHPARTNER,
      uuid: uuidv1(),
    };
    const entityData = [...this.data, NEW_ANSPRECHPARTNER];
    this.updateEntityData(entityData);
  };

  handleRemove = uuid => {
    const entityData = this.data.filter(i => i.uuid !== uuid);
    this.updateEntityData(entityData);
  };

  updateEntityData = entityData => {
    this.props.pagesStore.currentPage.updateEntityData(
      this.props.block.getKey(),
      this.entityKey,      
      { ansprechpartner: JSON.stringify(entityData) }
    );
  };

  handleFocus = e => {
    // e.preventDefault();
    // e.stopPropagation();
    // this.props.appStore.setPaused(true);
    // this.setState({
    //   editable: true,
    // });
  };

  handleBlur = () => {
    // if (!this.state.editable || this.state.isModalOpen) return;
    // this.props.appStore.setPaused(false);
    // this.setState({
    //   editable: false,
    // });
  };

  handleOpenModal = () => {
    this.props.onPreventClickAway(true);
    this.setState({
      isModalOpen: true,
    });
  };

  handleCloseModal = () => {
    this.props.onPreventClickAway(false);
    this.setState({
      isModalOpen: false,
    });
  };

  render() {
    const { isInteractive, appStore, classes, cols } = this.props;
    return (
      <Box pt={4} pb={4}>
        <GridList cellHeight="auto" cols={cols}>
          {this.data.map(d => (
            <GridListTile key={d.uuid} cols={1}>
              <AnsprechpartnerBox
                isEditable={isInteractive}
                readOnly={!appStore.editMode}
                onReceiveInput={this.handleReceiveInput}
                onRemove={this.handleRemove}
                onSetImage={this.handleSetImage}
                onOpenModal={this.handleOpenModal}
                onCloseModal={this.handleCloseModal}
                {...d}
              />
            </GridListTile>
          ))}
          {appStore.editMode && (
            <GridListTile cols={1}>
              <Box
                className={classes.dummy}
                onClick={this.addAnsprechpartner}
                p={1}
              >
                <Box className={classes.dummyImg}>
                  <Typography
                    className={classes.dummyText}
                    component="span"
                    variant="body2"
                    align="center"
                  >
                    Zum hinzufügen klicken
                  </Typography>
                </Box>
                {Object.keys(ANSPRECHPARTNER).map(key => {
                      // eslint-disable-line
                  return (
                    <Typography className={key} variant="body2" key={key}>
                      {ANSPRECHPARTNER[key]}
                    </Typography>
                  );
                })}
              </Box>
            </GridListTile>
          )}
        </GridList>
      </Box>
    );
  }
}

const AnsprechpartnerBlockWithCols = props => {
  const cols = useResponsiveCols(4, { sm: 3, xs: 2 });
  return <AnsprechpartnerBlock {...props} cols={cols} />;
};

export default AnsprechpartnerBlockWithCols;
